import React from 'react';
import ReactDOM from 'react-dom';
import ThemeService from './services/ThemeService';
import '../../scss/theme.scss';
import Timer from "../../react/Timer/Timer";


window.BOLD = window.BOLD || {};
window.BOLD.BMS = window.BOLD.BMS || {};
window.BOLD.BMS.BUILDS = window.BOLD.BMS.BUILDS || {};

const initializeApp = (settings) => {
  try {
    settings.discountLength = settings.discountLength * 60 * 1000; // converting min --> ms
    settings.discountFlat = parseInt(settings.discountFlat);
    settings.delimiter = '~~';
    Object.freeze(settings); // Locking in as read-only.
    new ThemeService(settings);
  }
  catch(e){
    console.error("Malformed Liquid Settings, cannot initialize bold.theme.bundle.js", e);
  }
}




const initializeFireNetTimerWidget = (elem, data) => {
  ReactDOM.render(<Timer widgetData={data} />, elem);
}



window.BOLD.BMS.BUILDS.initializeFunnelApp = initializeApp;
window.BOLD.BMS.BUILDS.initializeFirenetTimerWidget = initializeFireNetTimerWidget;